import { ArrowBackProps } from './ArrowBack.types';
import * as S from './ArrowBack.styles';

const ArrowBack = (props: ArrowBackProps): JSX.Element => <S.Container {...props} />;

export default ArrowBack;
